import { Box } from '@mui/material';
import React from 'react';

interface TabPanelProps {
    children: React.ReactNode;
    value: number;
    index: number;
}

export const TabPanel: React.FC<TabPanelProps> = ({ children, value, index }) => {
    return (
        <Box
            role="tabpanel"
            id={`settings-tabpanel-${index}`}
            aria-labelledby={`settings-tab-${index}`}
            sx={{ display: value === index ? 'block' : 'none', pt: 1 }}
        >
            {children}
        </Box>
    );
};
